import { useQuery } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import { useStrategy } from '../hooks/useStrategy'
import endpoints from '../../API/endpoints'
import callAPI from '../../API/callSecureAPI'

export type OrgActivity = {
    _id: string
    title: string
    titleLong?: string
    category?: string
    function?: string
    indication?: string
    genericName?: string
    source?: string
    status?: string
    description?: string
    startDate?: string
    endDate?: string
    plannedStartDate?: string
    plannedEndDate?: string
    studyNumber?: string
    therapeuticArea?: string
    compoundName?: string
    affiliateName?: string
    providerName?: string
    sponsorType?: string
    countries?: string[]
    studyReportDate?: string
    terminationDate?: string
    resultsAvailableForExternalUseDate?: string
    studyOwner?: string
    vendorDetails?: string
    type?: string
    population?: string
    externalId?: string
    lastSyncedAt?: string
    updatedAt?: string
    roadmapNames?: string[]
}

const ONE_MINUTE = 1000 * 60
const FIVE_MINUTES = ONE_MINUTE * 5

export const useGetOrgActivitiesQuery = () => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()
    const strategy = useStrategy()
    const organizationId = strategy?.organizationId

    const getOrgActivities = async () => {
        const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
        const { url, method } = endpoints.getAllActivitiesByOrg
        const response = await callAPI(`${url}${organizationId}`, method, token)
        return (response.data ?? []) as OrgActivity[]
    }

    return useQuery<OrgActivity[]>(['orgActivities', organizationId], getOrgActivities, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!organizationId,
        cacheTime: FIVE_MINUTES,
        staleTime: FIVE_MINUTES,
        refetchOnWindowFocus: false,
        retry: 3,
    })
}
